(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ctr-future-gifts"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__ctrFutureGiftsInit) return;
    window.__ctrFutureGiftsInit = true;

    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-ctr-future-gifts-toggle]');
      if (!toggle) return;
      var root = toggle.closest('[data-ctr-future-gifts]');
      var open = !root.classList.contains('is-open');
      root.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ctr-otp-link"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__ctrOtpLinkInit) return;
    window.__ctrOtpLinkInit = true;

    function formatPrice(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function getHostForm() {
      return (
        document.querySelector('ctr-product-form') ||
        document.querySelector('product-form')
      );
    }

    function getAddToCartForm(host) {
      if (!host) return null;
      if (host.matches('form')) return host;
      return host.querySelector('form[data-type="add-to-cart-form"], form');
    }

    function placeUnderProductForm(root) {
      var host = getHostForm();
      if (!host || !root) return;
      host.insertAdjacentElement('afterend', root);
    }

    function initRoot(root) {
      var link = root.querySelector('[data-ctr-otp-anchor]');
      var priceEl = root.querySelector('[data-ctr-otp-price]');
      var compareEl = root.querySelector('[data-ctr-otp-compare]');
      var variantsEl = root.querySelector('[data-ctr-otp-variants]');
      if (!link || !priceEl || !compareEl || !variantsEl) return;

      var variants = [];
      try {
        variants = JSON.parse(variantsEl.textContent);
      } catch (error) {}

      var currentVariantId = root.getAttribute('data-initial-variant-id');

      function updatePriceDisplay(variant) {
        if (!variant) return;
        currentVariantId = variant.id;
        priceEl.textContent = formatPrice(variant.price);

        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatPrice(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.textContent = '';
          compareEl.hidden = true;
        }
      }

      function getVariantFromUrl() {
        var params = new URLSearchParams(window.location.search);
        var variantId = params.get('variant');
        if (!variantId) return;
        var variant = variants.find(function (item) {
          return String(item.id) === String(variantId);
        });
        if (variant) updatePriceDisplay(variant);
      }

      document.addEventListener('change', function (event) {
        if (event.target.closest('variant-selects, ctr-variant-selects, .ctr-variant-picker')) {
          setTimeout(getVariantFromUrl, 50);
        }
      });

      var lastUrl = location.href;
      new MutationObserver(function () {
        if (location.href !== lastUrl) {
          lastUrl = location.href;
          getVariantFromUrl();
        }
      }).observe(document.body, { subtree: true, childList: true });

      link.addEventListener('click', function (event) {
        event.preventDefault();
        if (!currentVariantId) return;

        var host = getHostForm();
        var productForm = getAddToCartForm(host);
        if (!productForm) return;

        var originalInput = productForm.querySelector('input[name="id"]');
        if (!originalInput) return;

        var originalValue = originalInput.value;
        originalInput.value = currentVariantId;

        var sellingPlanInput = productForm.querySelector('input[name="selling_plan"]');
        var sellingPlanValue = null;
        if (sellingPlanInput) {
          sellingPlanValue = sellingPlanInput.value;
          sellingPlanInput.remove();
        }

        productForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));

        originalInput.value = originalValue;
        if (sellingPlanValue !== null) {
          var newSellingPlan = document.createElement('input');
          newSellingPlan.type = 'hidden';
          newSellingPlan.name = 'selling_plan';
          newSellingPlan.value = sellingPlanValue;
          productForm.appendChild(newSellingPlan);
        }
      });

      placeUnderProductForm(root);
      getVariantFromUrl();
    }

    function initAll() {
      document.querySelectorAll('[data-ctr-otp-link]').forEach(initRoot);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shipping-eta-badge"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__shippingEtaBadgeInit) return;
    window.__shippingEtaBadgeInit = true;

    function getPartsInTimeZone(date, timeZone) {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: timeZone,
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
      }).formatToParts(date);

      var values = {};
      for (var i = 0; i < parts.length; i++) {
        var part = parts[i];
        if (part.type !== 'literal') values[part.type] = Number(part.value);
      }

      return values;
    }

    function addBusinessDays(businessDays, timeZone) {
      var parts = getPartsInTimeZone(new Date(), timeZone);
      var year = parts.year;
      var month = parts.month;
      var day = parts.day;
      var added = 0;

      while (added < businessDays) {
        day += 1;
        var cursor = new Date(Date.UTC(year, month - 1, day));
        year = cursor.getUTCFullYear();
        month = cursor.getUTCMonth() + 1;
        day = cursor.getUTCDate();

        var weekday = cursor.getUTCDay();
        if (weekday !== 0 && weekday !== 6) added += 1;
      }

      return { year: year, month: month, day: day };
    }

    function formatArrival(parts) {
      return new Intl.DateTimeFormat('en-US', {
        month: 'long',
        day: 'numeric',
        timeZone: 'UTC',
      }).format(new Date(Date.UTC(parts.year, parts.month - 1, parts.day)));
    }

    function updateBadges() {
      var badges = document.querySelectorAll('[data-shipping-eta-badge]');
      if (!badges.length) return;

      var first = badges[0];
      var businessDays = parseInt(first.getAttribute('data-business-days'), 10) || 3;
      var timeZone = first.getAttribute('data-timezone') || 'America/New_York';
      var arrival;

      try {
        arrival = formatArrival(addBusinessDays(businessDays, timeZone));
      } catch (error) {
        arrival = formatArrival(addBusinessDays(businessDays, 'America/New_York'));
      }

      var dateNodes = document.querySelectorAll('[data-shipping-eta-date]');
      for (var i = 0; i < dateNodes.length; i++) {
        dateNodes[i].textContent = arrival;
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateBadges);
    } else {
      updateBadges();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sitewide-promo-banner"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.sitewidePromoTimers) return;
  window.sitewidePromoTimers = true;

  var banners = document.querySelectorAll('[data-sitewide-promo-end]');
  if (!banners.length) return;

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function tick() {
    var now = Date.now();
    banners.forEach(function (banner) {
      if (banner.hidden) return;
      var endMs = parseInt(banner.getAttribute('data-sitewide-promo-end'), 10) * 1000;
      var startMs = parseInt(banner.getAttribute('data-sitewide-promo-start') || '0', 10) * 1000;
      var from = startMs > now ? startMs : now;
      var remaining = Math.floor((endMs - from) / 1000);
      if (remaining <= 0) {
        banner.hidden = true;
        return;
      }
      var hours = banner.querySelector('[data-sitewide-promo-hours]');
      var mins = banner.querySelector('[data-sitewide-promo-mins]');
      var secs = banner.querySelector('[data-sitewide-promo-secs]');
      if (hours) hours.textContent = pad(Math.floor(remaining / 3600));
      if (mins) mins.textContent = pad(Math.floor((remaining % 3600) / 60));
      if (secs) secs.textContent = pad(remaining % 60);
    });
  }

  tick();
  window.setInterval(tick, 1000);
})();
  } catch(e) { console.error(e); }
})();

})();
